import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdsForSettingsService } from '../../../ids-for-settings.service';
import { BreadCrumbOptions, SettingsBreadCrumbService } from '../../../settings-breadcrumb.service';

@Component({
    templateUrl: './organisation-user-profile.page.html'
})
export class OrganisationUserProfilePage implements OnInit, OnDestroy {

    selectedUserGuid!: string;
    subscription!: Subscription;
    constructor(private idsForSettingsService: IdsForSettingsService, private settingsBreadCrumbService: SettingsBreadCrumbService) {
    }
    ngOnInit(): void {
        this.subscription = this.idsForSettingsService.selectedUserid$.subscribe(selectedUserGuid => {
            this.selectedUserGuid = selectedUserGuid;
            // setup specialised breadcrumb with userId
            this.settingsBreadCrumbService.SetOrganisationUserCrumbs(BreadCrumbOptions.Organisation_User_Selected_Profile, this.selectedUserGuid);
        });
    }
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
